// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"b01c11d6","635":"a9ae0274","878":"50f902c5","927":"5b083bd3"}[chunkId] + ".chunk.css";
};